export default __webpack_public_path__ + "alberta-filter-multiple.84a40d49f658c7fdc05c.svg";